import React from 'react';
import SimpleProductPage from './PriceComparison/SimpleProductPage';
import { 
  findProductById, 
  getProductDisplayName, 
  getProductImage, 
  getProductCsvLookupId 
} from '../utils/productHelpers';

const SimpleUltra2106svLVS34Bundle = () => {
  console.log('🎯 SimpleUltra2106svLVS34Bundle component loading');
  
  const product = findProductById("Ultra2 106sv + LVS34 Bundle");
  
  if (!product) {
    console.error('Product not found:', "Ultra2 106sv + LVS34 Bundle");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="Ultra2 106sv + LVS34 Bundle"
      productName={getProductDisplayName(product)}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
    />
  );
};

export default SimpleUltra2106svLVS34Bundle; 